// Libs
import { useContext } from 'react';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { BaseInput } from '~/components/common';
// Others
import { LoadingContext } from '~/context';
import { IFormForgotPassword } from '~/utils/interface/auth';
import { authRouteAbsolute } from '~/utils/routes/auth';
import { useAppDispatch } from '~/utils/redux/hooks';
import { defaultValuesForm, schema } from './helper';
import { VerifyTypeEnum } from '~/utils/enum/common';
import { forgotPassword } from '~/thunks/auth/authThunk';
// Styles, images, icons
import styles from './ForgotPassword.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const ForgotPassword = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/auth']);
  const loadingContext = useContext(LoadingContext);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormForgotPassword>({
    resolver: yupResolver(schema(t)),
    defaultValues: defaultValuesForm,
  });
  //#endregion Declare Hook

  //#region Selector

  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleForgotPassword = (data: IFormForgotPassword) => {
    loadingContext?.show();

    dispatch(forgotPassword(data))
      .unwrap()
      .then((resp) => {
        if (!resp.data) return;

        const { accountId } = resp?.data;
        navigate(`${authRouteAbsolute.verifyCode}?id=${accountId}&type=${VerifyTypeEnum.FORGOT_PASSWORD}`);
      })
      .catch((_error) => {})
      .finally(() => {
        loadingContext?.hide();
      });
  };
  //#endregion Handle Function

  return (
    <Box
      id='forgotPasswordPage'
      className={cx('container')}
      component={'form'}
      onSubmit={handleSubmit(handleForgotPassword)}
    >
      <Stack direction={'column'} spacing={'5px'} alignItems={'center'}>
        <Typography className={cx('pageName')}>{t('forgot_password_title')}</Typography>

        <Typography className={cx('description')}>{t('forgot_password_description')}</Typography>
      </Stack>

      <Stack direction={'column'} spacing={'20px'} marginTop={'10px'}>
        <Controller
          name='email'
          control={control}
          render={({ field: { value, onChange } }) => (
            <BaseInput
              height={52}
              borderRadius={'6px'}
              label={t('login_label_email_or_phone')}
              placeholder={t('login_placeholder_email_or_phone')}
              value={value}
              onChange={onChange}
              errorMessage={errors?.email?.message}
            />
          )}
        />

        <Button variant='contained' className={cx('buttonForgot')} type='submit' size='large'>
          {t('forgot_password_button_reset_password')}
        </Button>
      </Stack>
    </Box>
  );
};

export default ForgotPassword;
